import type { OtpChannel } from "@jti/fe-common";

export const getIsOtpChannel = (value: string): value is OtpChannel =>
  value === "sms" || value === "whatsapp" || value === "email" || value === "viber";
